module.exports = __webpack_public_path__ + "static/img/IMG_20241023_165229.8624a2db.jpg";